import { jsx as _jsx } from "react/jsx-runtime";
import { BarChartOutlined, CloudOutlined, ExperimentOutlined, LoginOutlined, LogoutOutlined, MenuOutlined, PictureOutlined, SafetyCertificateOutlined, TagOutlined } from "@ant-design/icons";
import { Layout as AntdLayout, App, Menu } from "antd";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EUserRole } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../others/i18n.js";
import { useStores } from "../../store/root.js";
import { colors } from "../../styles/colors.js";
import { ESessionState } from "../../types/store/authentication.js";
import { getItem } from "../../util/menu.js";
import { confirmLogout } from "../../util/session.js";
import { updateSiderCollapseState } from "../../util/store/settings.js";
const { Sider: AntdSider } = AntdLayout;
var ERcbSiderMenu = /*#__PURE__*/ function(ERcbSiderMenu) {
    ERcbSiderMenu["Logout"] = "logout";
    ERcbSiderMenu["ToggleMenu"] = "toggleMenu";
    ERcbSiderMenu["Statistics"] = "rcb/statistics";
    ERcbSiderMenu["Services"] = "rcb/service";
    ERcbSiderMenu["ContentBlocker"] = "rcb/content-blocker";
    ERcbSiderMenu["Releases"] = "rcb/releases";
    ERcbSiderMenu["PreRelease"] = "rcb/pre-release";
    ERcbSiderMenu["Media"] = "rcb/media";
    return ERcbSiderMenu;
}(ERcbSiderMenu || {});
const Sider = observer(({ siderWidth, activeAdminService })=>{
    const app = App.useApp();
    const { t } = useTranslation();
    const location = useLocation();
    const { rcbAuthenticationStore, rcbUserSettingsStore } = useStores();
    const navigate = useNavigate();
    const activateServiceRoute = location.pathname.replace(/^(\/)/, "");
    const matchingMenu = Object.values(ERcbSiderMenu).find((menu)=>activateServiceRoute.startsWith(menu));
    const items = {
        rcb: rcbAuthenticationStore.sessionState === ESessionState.Stored ? [
            getItem({
                label: t("Services"),
                key: "rcb/service",
                icon: /*#__PURE__*/ _jsx(CloudOutlined, {})
            }),
            getItem({
                label: t("Content Blocker"),
                key: "rcb/content-blocker",
                icon: /*#__PURE__*/ _jsx(SafetyCertificateOutlined, {})
            }),
            getItem({
                label: t("Media"),
                key: "rcb/media",
                icon: /*#__PURE__*/ _jsx(PictureOutlined, {}),
                hidden: !rcbAuthenticationStore.hasRole(EUserRole.Admin)
            }),
            getItem({
                label: t("Pre-Release"),
                key: "rcb/pre-release",
                icon: /*#__PURE__*/ _jsx(ExperimentOutlined, {}),
                hidden: !rcbAuthenticationStore.hasRole(EUserRole.Admin)
            }),
            getItem({
                label: t("Releases"),
                key: "rcb/releases",
                icon: /*#__PURE__*/ _jsx(TagOutlined, {}),
                hidden: !rcbAuthenticationStore.hasRole(EUserRole.Admin)
            }),
            getItem({
                label: t("Statistics"),
                key: "rcb/statistics",
                icon: /*#__PURE__*/ _jsx(BarChartOutlined, {}),
                hidden: !rcbAuthenticationStore.hasRole(EUserRole.Translator)
            }),
            getItem({
                label: t("Logout"),
                key: "logout",
                icon: /*#__PURE__*/ _jsx(LogoutOutlined, {})
            })
        ] : [
            getItem({
                label: t("Login"),
                key: "rcb/login",
                icon: /*#__PURE__*/ _jsx(LoginOutlined, {})
            })
        ],
        rc: [],
        rpm: []
    };
    // handle collapsed state of side menu
    const [collapsed, setCollapsed] = useState(rcbUserSettingsStore.settings.sider?.collapsed);
    const toggleItem = getItem({
        label: collapsed ? t("Expand menu") : t("Collapse menu"),
        key: "toggleMenu",
        icon: /*#__PURE__*/ _jsx(MenuOutlined, {}),
        style: collapsed ? {
            backgroundColor: colors.ci.devowlBlue,
            color: "white"
        } : {}
    });
    const toggleMenu = ()=>{
        setCollapsed(!collapsed);
        updateSiderCollapseState(!collapsed, rcbUserSettingsStore);
    };
    const menuItems = items[activeAdminService];
    menuItems?.unshift(toggleItem);
    const clickMap = {
        logout: ()=>confirmLogout(t, rcbAuthenticationStore, navigate, app),
        toggleMenu
    };
    const onMenuClick = (menuItem)=>{
        const clickFunction = clickMap[menuItem.key] || ((menuItem)=>{
            navigate(menuItem.key, {
                replace: true
            });
        });
        clickFunction(menuItem);
    };
    return /*#__PURE__*/ _jsx(AntdSider, {
        hidden: !menuItems,
        width: siderWidth,
        collapsible: true,
        collapsed: collapsed,
        trigger: null,
        children: /*#__PURE__*/ _jsx(Menu, {
            onClick: onMenuClick,
            mode: "inline",
            selectedKeys: [
                matchingMenu
            ],
            style: {
                height: "100%",
                paddingTop: 10
            },
            items: menuItems
        })
    });
});
export { Sider };
